class CustomError extends Error {
    constructor(message, status, text = (message.message || message)) {
        super(message);
        this.status = status;
        this.text = text;
    }
}

export default CustomError;